import { render, staticRenderFns } from "./setup-admin.vue?vue&type=template&id=938fe4e4&"
import script from "./setup-admin.vue?vue&type=script&lang=js&"
export * from "./setup-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports